import axios from 'axios';
import * as THREE from "three";
import { toast } from 'react-toastify';

import React, { useEffect, useState, useCallback } from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography'
import Checkbox from "@material-ui/core/Checkbox";
import RadioGroup from '@material-ui/core/RadioGroup'
import SideStyle from '../style/sideStyle';
import { GreyRadio } from '../style/customUI';
import { loadSTLFile, loadPLYFile } from '../fileIO/fileLoader';

import Param from '../store/param';
import Control from '../store/control';

import { ThreeDRotation } from '@material-ui/icons';
import ModalForPatientsFile from './components/modalForPatientsFile';


const FormSetup = () => {
  const [isShowLeg, setIsShowLeg] = useState(false);
  const [show, setShow] = useState(false);
  const [pullModal, setPullModal] = useState(false);

  const style = SideStyle();
  const param = Param.Get('setup');
  const compress = Param.Get('compress');
  const trim = Param.Get('trim');
  const setParam = Param.Get('setParam');
  const setControl = Control.Get('setControl');

  const meshLeg = Control.Get('meshLeg');
  const pointCross = Control.Get('pointCross');
  const showMirror = Control.Get('showMirror');


  const handleValueScan = (e) => {
    loadPLYFile(e.target.files[0], (mesh) => {
      setControl(s => { s.meshLeg = mesh, s.redrawBox = true }); // s.type = 'TestSocket', 
      setControl(s => { s.showLeg = true })
    });
    console.log(e.target.files[0].name);

    toast.info('Wait for few seconds to initiate the position.' , {autoClose: 3000});
    setTimeout(() => {
      setCenterButton();
    }, '1000');
  }

  const setCenterButton = () => {
    setControl(s => {s.toCenterButton = true});
  };

  const handleValueSide = (e) => {
    setParam(s => {s.setup.side = Number(e.target.value)});
  };

  const insertValue = (array, part, addValue) => {
    var tmp = [];
    for (var i = 0; i < array.length; i += part) {
      if (addValue) {
        tmp.push(addValue, ...array.slice(i, i + part));
      } else {
        tmp.push(array.slice(i, i + part));
      }
    }
    return tmp;
  }

  const onTest = useCallback((target) => {
    console.log("TestTrim");

    const trimPoints = [[-4.7, 27, 59],
    [4.7, 30, 58],
    [33, 40, 41],
    [46, 50, 20],
    [48, 40, -1],
    [43, 15, -22],
    [17, 0, -52],
    [-5, -6, -56],
    [-29, 0, -52],
    [-57, 15, -22],
    [-61, 40, -1],
    [-54, 50, 20],
    [-40, 40, 41],
    [-18, 30, 58]]

    // axios settings
    const url = process.env.REACT_APP_BACKEND_URL + "/testTrim";
    const data = {
      "smooth": Number(trim.smooth),
      "nTrimPointsMod": Number(trim.nTrimPointsMod),
      "trimPoints": trimPoints,
    };
    const header = {
      headers: {
        'Content-Type': 'application/json',
      }
    };

    axios.post(url, data, header)
      //axios.get(url)
      .then(res => {
        console.log('get data from server to client');

        // socket mesh surface
        if (true) {
          const socketVertices = res.data['socketVertices'];
          const socketFaces = res.data['socketFaces'];

          var vertices = [];
          var faces = [];
          var face = [];
          var nFace = [];
          var temp = [];

          // convert to numpy array to three array
          for (var i = 0; i < socketVertices.length; i++) {
            var p = new THREE.Vector3(...socketVertices[i]);
            vertices.push(p);
          }

          console.log(socketFaces.length)
          // convert to numpy array to three array
          for (var i = 0; i < socketFaces.length; i++) {
            nFace = socketFaces[i];
            face = socketFaces.slice(i + 1, i + nFace + 1);

            if (nFace == 3) {
              //faces.push(new THREE.Face3(...face)); // this is for geometry format, but departed and not working well
              faces.push(...face) // this is for buffergeometry
            } else if (nFace == 4) { // devide quad mesh into two triangle mesh
              temp = [face[0], face[1], face[2]];
              //faces.push(new THREE.Face3(...temp)) // this is for geometry
              faces.push(...temp) // this is for buffergeometry
              temp = [face[0], face[2], face[3]];
              //faces.push(new THREE.Face3(...temp)) // this is for geometry
              faces.push(...temp) // // this is for buffergeometry
            }

            i += nFace;
          }

          var temp = {
            vertices: res.data['socketVertices'],
            faces: res.data['socketFaces'],
          };
          console.log(temp)
          setControl(s => { s.meshSocketTrimVtk = temp });

          temp = {
            vertices: vertices,
            faces: faces,
          };
          console.log(temp)
          setControl(s => { s.meshSocketTrim = temp });
        }
      })
      .catch(err => {
        console.log('error');
      });
  })

  const onTestModify = useCallback((target) => {
    console.log("TestModify");

    const outerPoints = [[18.9 + 10, -44.6, 0 + 150],
    [13 + 5, -50.1, 5.7 + 10 + 150],
    [-1.1 - 5, -53.8, 8 + 10 + 150],
    [-15.3 - 5, -52, 5.7 + 5 + 150],
    [-21.1 - 10, -48.5, 9.8 + 150],
    [-15.3 - 5, -48.3, -5.7 - 5 + 150],
    [-1.1 - 5, -48.8, -8 - 10 + 150],
    [13 + 5, -45.6, -5.7 - 10 + 150]]

    const innerPoints = [[14.9 + 10, -47, 0 + 150],
    [10.2 + 5, -50, 2.8 + 10 + 150],
    [-1.1 - 5, -52, 4 + 10 + 150],
    [-12 - 5, -51, 2.8 + 5 + 150],
    [-17 - 10, -49, 4 + 150],
    [-12 - 5, -49, -2.8 - 5 + 150],
    [-1 - 5, -50, -4 - 10 + 150],
    [10, -48, -2.8 - 10 + 150]]

    // axios settings
    const url = process.env.REACT_APP_BACKEND_URL + "/testModify";
    const data = {
      //"smooth": Number(modify.smooth[modify.target]),
      //"depth": Number(modify.depth[modify.target])
      //"in_points": Vpoints2Points(modify.vptI[modify.target]),
      //"out_points": Vpoints2Points(modify.vptO[modify.target]),
      "smooth": 3,
      "depth": -50,
      "outerPoints": outerPoints,
      "innerPoints": innerPoints,
    };
    const header = {
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': 'application/json',
        //'Content-Type': 'application/x-www-form-urlencoded'
      }
    };

    axios.post(url, data, header)
      //axios.get(url)
      .then(res => {
        console.log('get data from server to client');

        // socket mesh surface
        if (true) {
          const socketVertices = res.data['socketVertices'];
          const socketFaces = res.data['socketFaces'];

          var vertices = [];
          var faces = [];
          var face = [];
          var nFace = [];
          var temp = [];

          // convert to numpy array to three array
          for (var i = 0; i < socketVertices.length; i++) {
            var p = new THREE.Vector3(...socketVertices[i]);
            vertices.push(p);
          }

          console.log(socketFaces.length)
          // convert to numpy array to three array
          for (var i = 0; i < socketFaces.length; i++) {
            nFace = socketFaces[i];
            face = socketFaces.slice(i + 1, i + nFace + 1);

            if (nFace == 3) {
              //faces.push(new THREE.Face3(...face)); // this is for geometry format, but departed and not working well
              faces.push(...face) // this is for buffergeometry
            } else if (nFace == 4) { // devide quad mesh into two triangle mesh
              temp = [face[0], face[1], face[2]];
              //faces.push(new THREE.Face3(...temp)) // this is for geometry
              faces.push(...temp) // this is for buffergeometry
              temp = [face[0], face[2], face[3]];
              //faces.push(new THREE.Face3(...temp)) // this is for geometry
              faces.push(...temp) // // this is for buffergeometry
            }

            i += nFace;
          }

          var temp = {
            vertices: vertices,
            faces: faces,
          };

          console.log(temp)

          setControl(s => { s.meshSocketModify = temp });
        }
      })
      .catch(err => {
        console.log('error');
      });
  })

  const onTestMultiCross20221128 = useCallback((target) => {
    console.log("Test");
    //setParam(s => {s.activeStep = -1})

    // mesh settings
    var vertexArray = [];
    var polyArray = [];

    vertexArray = meshLeg.geometry.attributes.position.array;
    polyArray = insertValue(meshLeg.geometry.index.array, 3, 3);

    //console.log(vertexArray)
    //console.log(polyArray)

    // axios settings
    const url = process.env.REACT_APP_BACKEND_URL + "/compress";
    const data = {
      "vertexArray": vertexArray,
      "polyArray": polyArray,
      "compressionWhole": Number(compress.compressionWhole),
      "interval": Number(compress.interval),
      "smoothnessWhole": Number(compress.smoothnessWhole),
      "bottomExtension": Number(compress.bottomExtension),
    };
    const header = {
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': 'application/json',
        //'Content-Type': 'application/x-www-form-urlencoded'
      }
    };

    axios.post(url, data, header)
      //axios.get(url)
      .then(res => {
        console.log('get data from server to client');
        console.log(res.data);

        const axis = new THREE.Vector3(1, 0, 0);
        const angle = -Math.PI / 2;
        const pointCrossAll = res.data['point'];
        const lineCrossAll = res.data['line'];
        const merdianPointsAll = res.data['merdianPoints'];
        const merdianLinesAll = res.data['merdianLines'];
        const meshSocket = res.data['meshSocket'];

        console.log(pointCrossAll)
        console.log(merdianPointsAll)

        var points = [];
        var pointsAlign = [];
        const pointsAll = [];
        const pointsMerdianAll = [];
        const pointsAlignAll = []; // cross section
        const pointsMerdianAlignAll = []; // merdian

        // cross section
        for (var i = 0; i < pointCrossAll.length; i++) {
          points = []
          var pointCross = pointCrossAll[i];
          if (pointCross.length == 0) {
            continue
          }

          for (var j = 0; j < pointCross.length; j++) {
            var p = new THREE.Vector3(...pointCross[j]);
            p.applyAxisAngle(axis, angle);
            points.push(p);
          }
          pointsAll.push(points)
        }


        for (var i = 0; i < lineCrossAll.length; i++) {
          pointsAlign = []
          var lineCross = lineCrossAll[i];
          if (lineCross.length == 0) {
            continue
          }
          for (var j = 0; j < lineCross.length; j++) {
            var idxLine = lineCross[j];
            pointsAlign.push(pointsAll[i][idxLine[0]]);
            pointsAlign.push(pointsAll[i][idxLine[1]]);
          }
          pointsAlignAll.push(pointsAlign);
        }

        setControl(s => { s.pointCross = pointsAlignAll });


        // merdian
        for (var i = 0; i < merdianPointsAll.length; i++) {
          points = []
          var merdianPoints = merdianPointsAll[i];
          if (merdianPoints.length == 0) {
            continue
          }

          for (var j = 0; j < merdianPoints.length; j++) {
            var p = new THREE.Vector3(...merdianPoints[j]);
            p.applyAxisAngle(axis, angle);
            points.push(p);
          }
          pointsMerdianAll.push(points)
        }

        for (var i = 0; i < merdianLinesAll.length; i++) {
          pointsAlign = []
          var line = merdianLinesAll[i];
          if (line.length == 0) {
            continue
          }
          for (var j = 0; j < line.length; j++) {
            var idxLine = line[j];
            pointsAlign.push(pointsMerdianAll[i][idxLine[0]]);
            pointsAlign.push(pointsMerdianAll[i][idxLine[1]]);
          }
          pointsMerdianAlignAll.push(pointsAlign);
        }

        setControl(s => { s.pointMerdian = pointsMerdianAlignAll });
      })
      .catch(err => {
        console.log('error');
      });
  })


  const onTest20221114 = useCallback((target) => {
    console.log("Testssa");
    //setParam(s => {s.activeStep = -1})

    // mesh settings
    var vertexArray = [];
    var polyArray = [];

    vertexArray = meshLeg.geometry.attributes.position.array;
    polyArray = insertValue(meshLeg.geometry.index.array, 3, 3);

    //console.log(vertexArray)
    //console.log(polyArray)

    // axios settings
    const url = process.env.REACT_APP_BACKEND_URL + "/compress";
    const data = {
      "vertexArray": vertexArray,
      "polyArray": polyArray,
      "compressionWhole": Number(compress.compressionWhole),
      "interval": Number(compress.interval),
      "smoothnessWhole": Number(compress.smoothnessWhole),
      "bottomExtension": Number(compress.bottomExtension),
    };
    const header = {
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': 'application/json',
        //'Content-Type': 'application/x-www-form-urlencoded'
      }
    };

    axios.post(url, data, header)
      //axios.get(url)
      .then(res => {
        console.log('get data from server to client');
        console.log(res.data);

        const axis = new THREE.Vector3(1, 0, 0);
        const angle = -Math.PI / 2;
        const pointCrossAll = res.data['point'];
        const lineCrossAll = res.data['line'];
        const merdianPointsAll = res.data['merdianPoints'];
        const merdianLinesAll = res.data['merdianLines'];

        var points = [];
        var pointsAlign = [];
        const pointsAll = [];
        const pointsMerdianAll = [];
        const pointsAlignAll = []; // cross section
        const pointsMerdianAlignAll = []; // merdian

        // cross section
        for (var i = 0; i < pointCrossAll.length; i++) {
          points = []
          var pointCross = pointCrossAll[i];
          if (pointCross.length == 0) {
            continue
          }

          for (var j = 0; j < pointCross.length; j++) {
            var p = new THREE.Vector3(...pointCross[j]);
            p.applyAxisAngle(axis, angle);
            points.push(p);
          }
          pointsAll.push(points)
        }


        for (var i = 0; i < lineCrossAll.length; i++) {
          pointsAlign = []
          var lineCross = lineCrossAll[i];
          if (lineCross.length == 0) {
            continue
          }
          for (var j = 0; j < lineCross.length; j++) {
            var idxLine = lineCross[j];
            pointsAlign.push(pointsAll[i][idxLine[0]]);
            pointsAlign.push(pointsAll[i][idxLine[1]]);
          }
          pointsAlignAll.push(pointsAlign);
        }

        setControl(s => { s.pointCross = pointsAlignAll });


        // merdian
        for (var i = 0; i < merdianPointsAll.length; i++) {
          points = []
          var merdianPoints = merdianPointsAll[i];
          if (merdianPoints.length == 0) {
            continue
          }

          for (var j = 0; j < merdianPoints.length; j++) {
            var p = new THREE.Vector3(...merdianPoints[j]);
            p.applyAxisAngle(axis, angle);
            points.push(p);
          }
          pointsMerdianAll.push(points)
        }

        for (var i = 0; i < merdianLinesAll.length; i++) {
          pointsAlign = []
          var line = merdianLinesAll[i];
          if (line.length == 0) {
            continue
          }
          for (var j = 0; j < line.length; j++) {
            var idxLine = line[j];
            pointsAlign.push(pointsMerdianAll[i][idxLine[0]]);
            pointsAlign.push(pointsMerdianAll[i][idxLine[1]]);
          }
          pointsMerdianAlignAll.push(pointsAlign);
        }

        setControl(s => { s.pointMerdian = pointsMerdianAlignAll });
      })
      .catch(err => {
        console.log('error');
      });
  })

  const onTest_20221109 = useCallback((target) => {
    console.log("Testssa");
    //setParam(s => {s.activeStep = -1})

    // mesh settings
    var vertexArray = [];
    var polyArray = [];

    vertexArray = meshLeg.geometry.attributes.position.array;
    polyArray = insertValue(meshLeg.geometry.index.array, 3, 3);

    //console.log(vertexArray)
    //console.log(polyArray)

    // axios settings
    const url = process.env.REACT_APP_BACKEND_URL + "/compress";
    const data = {
      'vertexArray': vertexArray,
      'polyArray': polyArray
    };
    const header = {
      headers: {
        //'Content-Type': 'multipart/form-data'
        'Content-Type': 'application/json',
        //'Content-Type': 'application/x-www-form-urlencoded'
      }
    };

    axios.post(url, data, header)
      //axios.get(url)
      .then(res => {
        console.log('get data from server to client');
        console.log(res.data);

        const axis = new THREE.Vector3(1, 0, 0);
        const angle = -Math.PI / 2;
        const pointCrossAll = res.data['point'];
        const lineCrossAll = res.data['line'];
        var points = [];
        var pointsAlign = [];
        const pointsAll = [];
        const pointsAlignAll = [];

        for (var i = 0; i < pointCrossAll.length; i++) {
          points = []
          var pointCross = pointCrossAll[i];
          if (pointCross.length == 0) {
            continue
          }

          for (var j = 0; j < pointCross.length; j++) {
            var p = new THREE.Vector3(...pointCross[j]);
            p.applyAxisAngle(axis, angle);
            points.push(p);
          }
          pointsAll.push(points)
        }

        for (var i = 0; i < lineCrossAll.length; i++) {
          pointsAlign = []
          var lineCross = lineCrossAll[i];
          if (lineCross.length == 0) {
            continue
          }
          for (var j = 0; j < lineCross.length; j++) {
            var idxLine = lineCross[j];
            pointsAlign.push(pointsAll[i][idxLine[0]]);
            pointsAlign.push(pointsAll[i][idxLine[1]]);
          }
          pointsAlignAll.push(pointsAlign);
        }

        setControl(s => { s.pointCross = pointsAlignAll });
      })
      .catch(err => {
        console.log('error');
      });
  })


  useEffect(() => {
    // active step
    setParam(s => { s.activestep = 0 })

    // Initialize the setup parameters.
    var obj = {}
    obj['f00'] = {}

    Object.keys(param).forEach(function (key) {
      obj['f00'][key] = param[key]
    });
  }, []);

  const handleValue = (e) => {
    setParam(s => { s.setup[e.target.name] = e.target.value })

    /*
    if (e.target.name == 'pathLeg') {
      setParam(s => { s.setup[e.target.name] = "C:\\Users\\shini\\Downloads\\" + e.target.files[0].name })
    } else {
      setParam(s => { s.setup[e.target.name] = e.target.value })
    }

    var obj = {}
    obj['f00'] = {}
    Object.keys(param).forEach(function (key) {
      obj['f00'][key] = param[key]
    });

    // #TODO: param is not like check box, etc. So update at the below again
    if (e.target.name == 'pathLeg') {
      obj['f00'][e.target.name] = e.target.files[0].name
    } else if (e.target.name == 'side') {
      obj['f00'][e.target.name] = e.target.value
    }
    */
  };

  return (
    <div className={style.outside}>
      <ModalForPatientsFile visible={pullModal} setVisible={setPullModal} onUpload={handleValueScan} />
      <Grid container direction='row' justifyContent='center' alignItems='center' spacing={2}>
        {/*  scan button */}
        <Grid item xs={5}>
          <Button
            component="label"
            className={style.button}
          >
            <input
              id='file'
              accept={['.ply']}
              type='file'
              name='pathLeg'
              onChange={(e) => handleValueScan(e)}
            />
          </Button>
        </Grid>
        {/* <Grid item xs={5}>
          <Button onClick={() => setPullModal(true)} className={[style.button]} style={{ padding: 4, fontSize: 13 }} component="label">
            Pull from DB
          </Button>
        </Grid> */}
      </Grid>
      {/* side */}
      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={4}>
          <Typography>Side</Typography>
        </Grid>
        <Grid item xs={4}>
          <RadioGroup aria-label='side' name='side' value={param.side} onChange={handleValueSide} >
            <FormControlLabel value={0} control={<GreyRadio />} label='Left' />
            <FormControlLabel value={1} control={<GreyRadio />} label='Right' />
          </RadioGroup>
        </Grid>
      </Grid>
    </div>
  );
}
export default FormSetup;
